"use client";

import { useRef } from "react";
import { useEditorMode } from "@/features/lomdaEditorV2/store";
import { VideoPlayPauseButton } from "./lib/VideoPlayPauseButton";

interface SceneBackgroundVideoProps {
    src: string;
}

/**
 * Full-bleed background video for a scene. Tagged data-render-layer="0" so the
 * render engine hides it during the layer-1 PNG capture and composites the
 * video file directly via ffmpeg as the bottom layer.
 *
 * In editor mode, a hover-revealed corner button toggles play/pause.
 */
export function SceneBackgroundVideo({ src }: SceneBackgroundVideoProps) {
    const mode = useEditorMode();
    const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <div className="absolute inset-0 z-0 group/scene-video">
            <video
                ref={videoRef}
                src={src}
                data-render-layer="0"
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
            />
            {mode === "edit" ? (
                <VideoPlayPauseButton videoRef={videoRef} />
            ) : null}
        </div>
    );
}
